import { render } from "./PanelProducts.vue?vue&type=template&id=6d3e3174&scoped=true"
import script from "./PanelProducts.vue?vue&type=script&lang=js"
export * from "./PanelProducts.vue?vue&type=script&lang=js"

import "./PanelProducts.vue?vue&type=style&index=0&id=6d3e3174&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3e3174"]])

export default __exports__